import { formatPrice } from '@/lib/api';
import { useCart } from '@/lib/CartContext';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { toast } from 'sonner';

export default function ProductCard({ product }) {
    const { addItem } = useCart();

    const handleAdd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        addItem(product);
        toast.success(`${product.name} agregado al carrito`);
    };

    const hasDiscount = product.compare_price && product.compare_price > product.price;
    const discount = hasDiscount ? Math.round((1 - product.price / product.compare_price) * 100) : 0;

    return (
        <Link
            to={`/productos/${product.slug}`}
            data-testid={`product-card-${product.slug}`}
            className="product-card group block bg-white rounded-2xl border border-cp-border overflow-hidden"
        >
            <div className="relative aspect-square overflow-hidden bg-cp-surface-soft">
                {product.images?.[0] ? (
                    <img
                        src={product.images[0]}
                        alt={product.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-cp-text-muted">
                        Sin imagen
                    </div>
                )}
                {hasDiscount && (
                    <span className="absolute top-3 left-3 bg-cp-error text-white text-xs font-bold px-2.5 py-1 rounded-full">
                        -{discount}%
                    </span>
                )}
            </div>
            <div className="p-4">
                <h3 className="font-heading font-bold text-cp-text-main text-sm leading-tight mb-2 line-clamp-2 group-hover:text-cp-secondary transition-colors">
                    {product.name}
                </h3>
                <div className="flex items-center gap-2 mb-3">
                    <span className="text-lg font-bold text-cp-brand">
                        {formatPrice(product.price)}
                    </span>
                    {hasDiscount && (
                        <span className="text-sm text-cp-text-muted line-through">
                            {formatPrice(product.compare_price)}
                        </span>
                    )}
                </div>
                <button
                    data-testid={`add-to-cart-${product.slug}`}
                    onClick={handleAdd}
                    className="w-full flex items-center justify-center gap-2 bg-cp-secondary hover:bg-cp-secondary-hover text-white py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-95"
                >
                    <ShoppingCart size={16} />
                    Agregar
                </button>
            </div>
        </Link>
    );
}
